import * as tslib_1 from "tslib";
import Vue from 'vue';
import Vuex from 'vuex';
import AppConsts from '@/lib/AppConsts';
Vue.use(Vuex);
var AppModule = /** @class */ (function () {
    function AppModule() {
        this.namespaced = true;
        this.state = {
            cachePage: [],
            lang: '',
            isFullScreen: false,
            menuTheme: 'dark',
            themeColor: '',
            currentPageName: '',
            currentPath: [
                {
                    meta: { title: 'HomePage' },
                    path: '',
                    name: 'home'
                }
            ],
            isReload: false,
            messageCount: 0,
            dontCache: [],
            noticeList: [{
                    read: false,
                    type: 0,
                    title: 'First notice',
                    description: 'One day ago'
                }, {
                    read: false,
                    type: 1
                }, {
                    read: false,
                    type: 0,
                    title: 'Second notice',
                    description: 'One month ago'
                }],
            hasPermission: function (router) {
                if (!!router.meta.permission) {
                    return abp.auth.hasPermission(router.meta.permission);
                }
                else {
                    return true;
                }
            },
        };
        this.mutations = {
            logout: function (state) {
                localStorage.clear();
                sessionStorage.clear();
            },
            closePage: function (state, name) {
                state.cachePage.forEach(function (item, index) {
                    if (item === name) {
                        state.cachePage.splice(index, 1);
                    }
                });
            },
            initCachepage: function (state) {
                if (localStorage.cachePage) {
                    state.cachePage = JSON.parse(localStorage.cachePage);
                }
            },
            setCurrentPath: function (state, pathArr) {
                state.currentPath = pathArr;
            },
            setCurrentPageName: function (state, name) {
                state.currentPageName = name;
            },
            setIsReload: function (state, isReload) {
                state.isReload = isReload;
            },
        };
        this.actions = {
            login: function (content, payload) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    var rep, tokenExpireDate;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, abp.ajax.post('/api/TokenAuth/Authenticate', payload.data)];
                            case 1:
                                rep = _a.sent();
                                tokenExpireDate = payload.data.rememberMe ?
                                    (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) :
                                    undefined;
                                abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
                                abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, abp.appPath);
                                return [2 /*return*/];
                        }
                    });
                });
            }
        };
    }
    return AppModule;
}());
var appModule = new AppModule();
export default appModule;
